import React from 'react';
import { useIntl } from 'react-intl';
import SceneAction from '../SceneAction';
import ProppingIcon from '@ingka/ssr-icon/paths/t-shirt';
import ProppingIconVase from '@ingka/ssr-icon/paths/vase';
import { useSelector } from 'react-redux';
import { isProppingVisible, showPropping, hidePropping } from 'ducks/layout';
import { reportProppingStatus } from 'analytics/reporters';
import { useAppDispatch } from 'ducks/hooks';
import { rangeIsBesta, rangeIsEket } from 'utils/queryUtils';

const ProppingAction = (props: React.PropsWithoutRef<JSX.IntrinsicElements['button']>) => {
  const { formatMessage } = useIntl();

  const active = useSelector(isProppingVisible);
  const dispatch = useAppDispatch();
  const Icon = rangeIsBesta() || rangeIsEket() ? ProppingIconVase : ProppingIcon;

  return (
    <SceneAction
      {...props}
      label={
        active
          ? formatMessage({ id: 'storageone.sceneMenuHidePropping' })
          : formatMessage({ id: 'storageone.sceneMenuShowPropping' })
      }
      dataTestId="scene-propping-action"
      onClick={() => {
        reportProppingStatus({ enable: active });
        if (active) {
          dispatch(hidePropping());
        } else {
          dispatch(showPropping());
        }
      }}
      ssrIcon={Icon}
      enabled={active}
    />
  );
};

export default ProppingAction;
